export const environment = {
    environmentType: 'plusdoctor',
    appVersion: require("../../package.json").version, //Fetching vesion of application.

    production: true,
    endPoint: 'https://plusdoctor-api-test.ifourtechlab.com'
};
